var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    position: 'absolute',
    left: 0,
    top: 0,
    transform: ("translate(" + _vm.x + "px, " + _vm.y + "px)"),
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }